var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.018 1C8.46524 0.999931 6.94584 1.47789 5.64439 2.37582C4.34294 3.27375 3.31543 4.55301 2.68668 6.05822C2.05794 7.56343 1.855 9.22982 2.10253 10.855C2.35006 12.4801 3.03739 13.9941 4.08105 15.213C5.12471 16.4319 6.47979 17.3033 7.98167 17.7214C9.48356 18.1394 11.0676 18.0861 12.5415 17.5679C14.0154 17.0497 15.3156 16.089 16.2842 14.8023C17.2528 13.5157 17.8482 11.9585 17.998 10.32C18.0065 10.2221 17.9877 10.1237 17.9437 10.0372C17.8998 9.95061 17.8328 9.87969 17.7511 9.83327C17.6694 9.78685 17.5765 9.767 17.4842 9.7762C17.3919 9.7854 17.3042 9.82325 17.2321 9.885C16.2426 10.6684 15.0027 11.0091 13.7789 10.8339C12.555 10.6586 11.4448 9.98151 10.6868 8.94792C9.92875 7.91434 9.58335 6.60677 9.72481 5.30614C9.86626 4.0055 10.4833 2.81558 11.4433 1.992C11.5179 1.93295 11.5743 1.85183 11.6054 1.75886C11.6366 1.6659 11.6411 1.56523 11.6184 1.46955C11.5957 1.37386 11.5468 1.28743 11.4779 1.22114C11.409 1.15485 11.3231 1.11166 11.2311 1.097C10.8296 1.03239 10.4241 0.999961 10.018 1Z",
    stroke: "#35d269",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkTheme);
export default __webpack_public_path__ + "static/media/dark-theme.c324a8ad6fd226aeff722a76165193dc.svg";
export { ForwardRef as ReactComponent };